import { type FetchSocialFeedMeByFeedSlugParams, useLocale } from '@capsicum/common';
import { newsFeedKeys } from '@capsicum/socios-core';

import { useSocialFeedMeQuery } from '../data-access';
import { clearFeedPages, prepareFeedData } from '../util';

export const useMeSocialFeed = () => {
	const { locale } = useLocale();
	const key = newsFeedKeys.posts;
	const params: FetchSocialFeedMeByFeedSlugParams = {
		feedSlug: 'timeline',
		limit: 10,
		locale: locale
	};

	const {
		data,
		error,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isLoading,
		refetch: refetchQuery
	} = useSocialFeedMeQuery(key, params);

	const { feedData, metadata } = prepareFeedData(data);

	const refetch = async () => {
		clearFeedPages(key);
		await refetchQuery();
	};

	return {
		data: feedData,
		error,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isLoading,
		metadata,
		refetch
	};
};
